import { render, staticRenderFns } from "./game-aviatrix.vue?vue&type=template&id=5926bfdc"
import script from "./game-aviatrix.vue?vue&type=script&lang=js"
export * from "./game-aviatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-aviatrix.vue
// module id = CqoA
// module chunks = 0